import React, { useState, useEffect } from 'react';
import GLOBALS from "../../utils/Globals";
import AWS from 'aws-sdk';

// Configure the AWS SDK with your region and credentials
AWS.config.update({
    region: GLOBALS.AWS.S3_REGION,
    accessKeyId: GLOBALS.AWS.AWS_ACCESS_KEY_ID,
    secretAccessKey: GLOBALS.AWS.AWS_SECRET_ACCESS_KEY
  });
  
  const s3 = new AWS.S3();

  export function CheckIfBucketExists(bucketname) {
    console.log('CheckIfBucketExists')

    const [bucketName, setBucketName] = useState('');
    const [bucketExists, setBucketExists] = useState(null);
    const [error, setError] = useState(null);

    const checkBucketExists = async (bucketName) => {
        try {
          await s3.headBucket({ Bucket: bucketName }).promise();
          console.log('found')
          setBucketExists(true);
          setError(null);
        } catch (err) {
          if (err.statusCode === 404) {
            console.log('not found')
            setBucketExists(false);
          } else {
            setError(`Error checking if bucket exists: ${err.message}`);
          }
        }
      };
    

    return bucketExists;

  }
  
  